var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homecontainer",style:(' background-color:'+String(_vm.backgoundcolor))},[_c('GoodTitle',{attrs:{"goodinfo":_vm.goodinfo,"fontcolor":_vm.fontcolor}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imgsrc,"alt":"iphonese"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7bd547","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/subcomponents/GoodBriefInfo.vue
// module id = null
// module chunks = 